import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'
const url = store.getters.getPostUrl;
export default {
	selectEquipmentRepair(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/page',
			method: 'post',
			data: param,
		})
	},
  getApproveList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/flow/approveList?id='+param,
      method: 'post',
    })
  },
	getFaultList() {
		return request({
			url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=11',
			method: 'get'
		})
	},
	exportList(param,switched) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/export?switched='+switched,
			method: 'post',
			data: param,
		})
	},
	getPage(param,switched) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/page?switched='+switched,
			method: 'post',
			data: param,
		})
	},
	getTaskStatus(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/status',
			method: 'post',
			data: param,
		})
	},
	getRecordStatus(param,switched) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/status?switched='+switched,
			method: 'post',
			data: param,
		})
	},
	pageCount(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/pageCount',
			method: 'post',
			data: param,
		})
	},
	pageReasonCount(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/pageReasonCount',
			method: 'post',
			data: param,
		})
	},
	pageCountAll(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/pageCountAll',
			method: 'post',
			data: param,
		})
	},
	excelCount(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/excelCount',
			method: 'post',
			data: param,
		})
	},
	excelReasonCount(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/excelReasonCount',
			method: 'post',
			data: param,
		})
	},
	distribute(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/distribute',
			method: 'post',
			data: param,
		})
	},
	orderReceiving(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/orderReceiving?id=' + param,
			method: 'post',
		})
	},
	insert(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/insert',
			method: 'post',
			data: param,
		})
	},
	selectById(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/selectById',
			method: 'post',
			params: {
				'id': param
			}
		})
	},
	selectpdf(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/pdf',
			method: 'post',
			params: {
				'taskId': param
			}
		})
	},
	knowledge(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairKnowledge/know',
			method: 'post',
			data: param,
		})
	},
	knowledge2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairKnowledge/know2',
			method: 'post',
			data: param,
		})
	},
	maintainBegin(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/maintainBegin?id=' + param,
			method: 'post',
		})
	},
	maintainEnd(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/maintainEnd',
			method: 'post',
			data: param,
		})
	},
	solution(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/solution',
			method: 'post',
			data: param,
		})
	},
	appConfirm(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/appConfirm',
			method: 'post',
			data: param,
		})
	},
	webConfirm(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/webConfirm',
			method: 'post',
			data: param,
		})
	},
	acceptance(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/acceptance',
			method: 'post',
			data: param,
		})
	},
	rapidProcessing(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/rapidProcessing',
			method: 'post',
			data: param,
		})
	},
	saveCommit(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/appSaveCommit',
			method: 'post',
			data: param,
		})
	},
	riskConfrimListMes(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/riskList',
			method: 'post',
			params: param,
		})
	},
	close(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/close?id=' + param,
			method: 'post',
		})
	},
	back2(param,parm2) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/back?id=' + param+"&cause="+parm2,
			method: 'post',
		})
	},
	importSet(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/importSet',
			method: 'post',
			data: param,
		})
	},
	riskListAll(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/riskListAll',
			method: 'post',
			params: param,
		})
	},
	confirm(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/confirm',
			method: 'post',
			data: param,
		})
	},
	riskDetailListAll(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/riskDetailListAll',
			method: 'post',
			params: param,
		})
	},
	updateTime(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/upadteTime',
			method: 'put',
			data: param,
		})
	},
	selectUsePartList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentPart/selectUse',
			method: 'post',
			params: param,
		})
	},
	pageCountExcel(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/excelCount',
			method: 'post',
			data: param,
		})
	},
	selectPage(param,switched) {
		return request({
			url: store.getters.getPostUrl + 'mes/flow/selectPage?switched='+switched,
			method: 'post',
			data: param,
		})
	},
	selectPage2(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/flow/view',
			method: 'post',
			data: param,
		})
	},
	approve(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/flow/approve',
			method: 'post',
			params: param,
		})
	},
	approveStatus() {
		return request({
			url: store.getters.getPostUrl + 'mes/flow/approveStatus',
			method: 'post',
		})
	},
	deleteConfirm(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/equipmentRepairTask/deleteConfirm?taskId='+param,
			method: 'put',
		})
	},
	back(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/flow/back',
			method: 'post',
			params: param,
		})
	},
  repairTaskExportExcel(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentRepairTask/repairTaskExportExcel',
      method: 'post',
      data: param,
      responseType: 'blob'
    })
  },
  resumeExport(param){
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/recordExport',
      method: 'post',
      data: param,
      responseType: 'blob'
    })
  },
  countExport(param, switched){
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentRepairRecord/countExport',
      method: 'post',
      data: param,
      param: switched,
      responseType: 'blob'
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/malfunction/malfunction.js